import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
export const gtmSaveBuildClick = ({ componentType, linkText, linkUrl, model, trim, gtmBodyStyle, availabilityFlag, }) => {
    const gtmPayload = {
        availability_flag: availabilityFlag,
        body_style: gtmBodyStyle,
        trim,
        model,
        component_type: componentType,
        link_Url: linkUrl,
        link_text: linkText,
        cta_placement: 'build and price',
        cta_type: 'save build',
        event: 'bap_cta',
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export const gtmSaveBuildSave = ({ componentType, linkText, linkUrl, model, trim, gtmBodyStyle, availabilityFlag, }) => {
    const gtmPayload = {
        availability_flag: availabilityFlag,
        body_style: gtmBodyStyle,
        trim,
        model,
        component_type: componentType,
        link_Url: linkUrl,
        link_text: linkText,
        cta_placement: 'save build',
        cta_type: 'click',
        event: 'cta_click',
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export const gtmSaveBuildCancel = ({ componentType, linkText, linkUrl, model, trim, gtmBodyStyle, availabilityFlag, }) => {
    const gtmPayload = {
        availability_flag: availabilityFlag,
        body_style: gtmBodyStyle,
        trim,
        model,
        component_type: componentType,
        link_Url: linkUrl,
        link_text: linkText,
        cta_placement: 'save build',
        cta_type: 'click',
        event: 'cta_click',
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
